import { combineReducers, configureStore } from '@reduxjs/toolkit';
import korisnikReducer from './slice/KorisnikSlice';
import zahtjeviReducer from './slice/ZahtjeviSlice';
import usersReducer from './slice/UsersSlice';
import companiesReducer from './slice/CompaniesSlice';
import processesReducer from './slice/ProcessesSlice';
import trainingsReducer from './slice/TrainingsSlice';
import settingsReducer from './slice/SettingsSlice';
import searchDocumentsReducer from './slice/SearchDocumentsSlice';
import documentsFilterReducer from './slice/DocumentsFilterSlice';
import storage from 'redux-persist/lib/storage';
import { REHYDRATE, persistReducer, persistStore } from 'redux-persist';
import axiosApi from '../api/axiosApi';

const reducers = combineReducers({
  korisnik: korisnikReducer,
  zahtjevi: zahtjeviReducer,
  users: usersReducer,
  companies: companiesReducer,
  processes: processesReducer,
  trainings: trainingsReducer,
  settings: settingsReducer,
  searchDocuments: searchDocumentsReducer,
  documentsFiler: documentsFilterReducer,
});

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const customMiddleware = (store: any) => (next: any) => (action: any) => {
  if (action.type === REHYDRATE) {
    next(action);
    axiosApi.defaults.headers['Authorization'] = 'Bearer ' + store.getState().korisnik.accessToken;
  } else {
    next(action);
  }
};

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: { warnAfter: 128 },
      serializableCheck: false,
    }).concat(customMiddleware),
});

export let persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
